import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { v4 as uuidv4 } from 'uuid';
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 120 * 10000000 // request timeout
})


// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
   
    // 每个请求强行带公司id 2023/5/5 有志的需求
    const companyInfo = store.getters.companyInfo || null
    if(companyInfo  && companyInfo.id){
      if(config.method === 'get' || config.method === 'GET'){
        if(config.params){
          config.params.companyInfoId=companyInfo.id
   
        }
      }
      if(config.method === 'post' || config.method === 'POST'){
        if(config.data){
          config.data.companyInfoId=config.data.companyInfoId?config.data.companyInfoId:companyInfo.id
       
        }
      }
    }
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['eb-token'] = getToken()
    }
    
    config.headers['trace-id'] = uuidv4().split('-').join("")
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    // 如果是字节类型，直接返回
    if (res.constructor === Blob) {
      return response
    }
    if(res.constructor === ArrayBuffer){
      return response
    }

    // if the custom code is not 20000, it is judged as an error.
    if (res.code && res.code !== 200) {
      // 401: 用户信息验证无效; 402: 请先登陆;
      if (res.code === 401 || res.code === 402) {
        // 判断路径是移动端投标的不弹窗
        if(res.path==='/app/crm/bid/appBidList' || res.path==='/app/crm/bid/getBid'|| res.path==='/app/login' ){
          return
        }
        // store.dispatch('user/resetToken').then(() => {
        //   location.reload()
        // })
        // to re-login
        MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
          confirmButtonText: '重新登陆',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
        
      } else {
        console.log(401)
        if(res.code !== 401 && res.code !== 402){
          Message({
            message: res.message || 'Error',
            type: 'error',
            duration: 5 * 1000
          })
        }
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
